export const GAZ_DELIVERY_METHOD_OPTIONS = [
  { value: "Оптимальный маршрут", label: "оптимальная" },
  { value: "доставка шаландами", label: "доставка шаландами" },
  { value: "доставка манипулятором", label: "доставка манипулятором" },
];

export const UNLOAD_METHOD_OPTIONS = [
  "разгрузка манипулятором",
  "разгрузка краном",
  "без разгрузки",
];

const GAZ_DELIVERY_CATEGORY_NAMES = new Set([
  "бордюр",
  "бордюр дорожный",
  "брусчатка",
  "брусчатка и тротуарная плитка",
  "плитка тротуарная",
  "газонная решетка",
  "лоток водоотводный жби",
  "лоток водоотводный тротуарный",
]);

const UNIVERSAL_UNLOAD_HINTS = [
  "Если меньше 3 шаланд - дешевле манипулятор.",
  "Если больше 3 шаланд - дешевле краном, но проверь оба варианта.",
];

function normalizeText(value) {
  if (typeof value !== "string") {
    return "";
  }

  return value.trim().toLowerCase();
}

export function normalizeRegionCode(value) {
  const normalized = String(value || "").trim().toUpperCase();
  if (normalized === "МОСКВА" || normalized === "МОСКОВСКАЯ ОБЛАСТЬ") {
    return "МСК";
  }
  if (normalized === "САНКТ-ПЕТЕРБУРГ" || normalized === "ЛЕНИНГРАДСКАЯ ОБЛАСТЬ") {
    return "СПБ";
  }
  return normalized;
}

function shouldUseGazDeliveryCategoryByRegion(region) {
  return ["МСК", "КРД"].includes(normalizeRegionCode(region));
}

function isGazDeliveryCategory(value, region) {
  const normalized = normalizeText(value);
  if (normalized.includes("газобетон")) {
    return true;
  }

  if (!GAZ_DELIVERY_CATEGORY_NAMES.has(normalized)) {
    return false;
  }

  return shouldUseGazDeliveryCategoryByRegion(region);
}

function isGazobetonFlowProduct(product, region) {
  const calculator = normalizeText(product?.category);
  const productCategory = normalizeText(product?.product_group);
  const productName = normalizeText(product?.name);

  if (isGazDeliveryCategory(calculator, region)) {
    return true;
  }

  if (calculator === "газобетон и кирпич") {
    return true;
  }

  if (isGazDeliveryCategory(productCategory, region)) {
    return true;
  }

  if (productCategory.startsWith("u-блок") || productCategory === "клей" || productCategory === "добавка противоморозная") {
    return true;
  }

  return productName.includes("газобетон") || productName.startsWith("u-блок");
}

export function hasGazobetonProduct(products, region = null) {
  if (!Array.isArray(products) || products.length === 0) {
    return false;
  }

  return products.some((product) => {
    if (!product || typeof product !== "object") {
      return false;
    }

    return isGazobetonFlowProduct(product, region);
  });
}

export function getUnloadQuestionsByMethod(unloadMethod) {
  if (!UNLOAD_METHOD_OPTIONS.includes(unloadMethod)) {
    return ["Список уточняющих вопросов временно обновляется."];
  }

  return UNIVERSAL_UNLOAD_HINTS;
}

/**
 * Одинаковы ли два состояния способа доставки по значению.
 *
 * Нужно, чтобы не подменять объект, когда меняться нечему. Раздел «Товары»
 * перезапрашивает способы доставки на каждое изменение состава — в том числе
 * когда добавили пустую строку. Если после такого запроса записать в состояние
 * новый объект с тем же содержимым, App примет это за смену способа доставки и
 * снимет с экрана готовый расчёт: страница схлопывается вдвое, прокрутка
 * упирается в короткий документ, и менеджер оказывается не там, где был.
 *
 * Сравнение поверхностное: значения здесь — строки («Оптимальный маршрут»,
 * выбранный способ разгрузки, режим доставки МСК), вложенных объектов нет.
 */
export function isSameDeliveryMethod(prev, next) {
  if (prev === next) {
    return true;
  }
  if (!prev || !next || typeof prev !== "object" || typeof next !== "object") {
    return false;
  }

  const prevKeys = Object.keys(prev);
  const nextKeys = Object.keys(next);

  if (prevKeys.length !== nextKeys.length) {
    return false;
  }

  return prevKeys.every((key) => prev[key] === next[key]);
}
